module.exports = __webpack_public_path__ + "img/fail.431a0732.svg";